<template>
	<ag-grid-vue
		v-bind="agReturnRequests"
		style="height: 70vh;" 
		class="ag-theme-alpine" 
		@grid-ready="onGridReady" 
		@cell-clicked="onCellClicked"
		@row-double-clicked="onRowDoubleClicked"
	/>
</template>
<script>
/* eslint-disable vue/no-unused-components */

import axios from 'axios';
import { AgGridVue } from "ag-grid-vue";
import Formats from "@/mixins/Formats.js";
import AgBadge from '@/components/AgGrid/AgBadge.vue';
import BaseLoader from '@/components/BaseLoader.vue';
import approvalStatus from '@/data/approvalStatus.json';
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import AgGrid from "@/mixins/AgGrid.js";

export default {
	mixins: [Formats, AgGrid],
	components: {
		AgGridVue,
		AgBadge,
		BaseLoader,
		agDateInput: FilterDate,
	},
	data() {
		return {
			salesPersonOptions: null,
			agReturnRequests: {
				columnDefs: [
					{ 
						field: "DocNum", 
						headerName: "# Solicitud",
						width: 90,
						filter: 'agTextColumnFilter',
						cellClass: "ag-clickable-cell text-blue font-weight-bold",
					},
					{ 
						field: "customer", 
						headerName: "Cliente", 
						cellClass: "font-weight-bold",
						filter: 'agTextColumnFilter',
						width: 300,
						cellRenderer: function({data}) {
              return `
                <div>
                  <span class="font-weight-bold">${data.CardName}</span>
                  <span class="font-weight-normal">${data.CardCode}</span>
                </div>
              `;
            }
					},
					{ 
						field: "DocDate", 
						headerName: "Fecha", 
						width: 80,
						filter: 'agDateColumnFilter', 
						valueFormatter: ({value}) => this.dateFormat(value),
					},
					{ 
						field: "DocDueDate", 
						headerName: "Vencimiento", 
						width: 100,
						filter: 'agDateColumnFilter',
						valueFormatter: ({value}) => this.dateFormat(value),
					},
					{
						field: "total",
						headerName: "Total",
						width: 120,
						filter: 'agNumberColumnFilter',
						valueFormatter: ({data}) => this.currencyFormat(data.total, data.DocCur),
						headerClass: "ag-right-aligned-header",
						type: 'rightAligned',
					},
					{ 
						field: "SlpCode", 
						headerName: "Vendedor",
						width: 120,
						valueFormatter: this.salesPersonFormatter,
						filter: 'agSetColumnFilter',
              filterParams: {
                values: (params) => {
                  if(this.salesPersonOptions){
                    params.success(this.salesPersonOptions.map((x) => x.SalesEmployeeCode));
                  } else {
                    this.watcherSalesPersons = this.$watch(() => this.salesPersonOptions, () => {
                      params.success(this.salesPersonOptions.map((x) => x.SalesEmployeeCode));
                      this.watcherSalesPersons(); // Remove watcher
                    })
                  }
                },
                valueFormatter: this.salesPersonFormatter,
                defaultToNothingSelected: true,
                applyMiniFilterWhileTyping: true,
              },
					},
					{ 
						field: "DocStatus", 
						headerName: "Estatus", 
						width: 100,
						cellClass: "text-center",
						filter: 'agSetColumnFilter',
						filterParams: {
							values: ['O', 'C'],
							valueFormatter: ({value}) => value === "O" ? "Abierta" : "Cerrada",
							defaultToNothingSelected: true,
							applyMiniFilterWhileTyping: true,
						},
						valueFormatter: ({value}) => value === "O" ? "Abierta" : "Cerrada",
						cellRendererSelector: ({value}) => {
							return {
								component: "AgBadge",
								params: {
									color: value === "O" ? "#5e72e4" : "#adb5bd"
								}
							}
						}
					},
					{
						headerName: "Aprobación", 
						field: "U_ApprovalStatus",
						width: 100,
						filter: 'agSetColumnFilter',
						filterParams: {
							values: approvalStatus.map((x) => x.id),
							valueFormatter: ({value}) => {
								const status = approvalStatus.find(x => x.id === value);
								return status ? status.name : value;
							},
							defaultToNothingSelected: true,
							applyMiniFilterWhileTyping: true,
						},
						cellClass: "text-center",
						valueFormatter: ({value}) => {
							const status = approvalStatus.find(x => x.id === value);
							return status ? status.name : value;
						},
						cellRendererSelector: ({value}) => {
							const status = approvalStatus.find(x => x.id === value);
							if(!status) return null;
							return {
								component: "AgBadge",
								params: {
									color: status.color
								}
							}
						},
					},
					{
						field: "Comments", 
						headerName: "Comentarios",
						width: 600,
						filter: "agTextColumnFilter",

					},
				],
				defaultColDef: {
					menuTabs: ["filterMenuTab"],
					cellDataType: false,
					floatingFilter: true,
					suppressFloatingFilterButton: true,
				},
				rowModelType: "serverSide",
        cacheBlockSize: 30,
        maxBlocksInCache: 10,
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
				loadingOverlayComponent: "BaseLoader",
				suppressCellFocus: true,
				enableCellTextSelection: true,
				localeText: AG_GRID_LOCALE_ES,
				alwaysShowVerticalScroll: true,
			},
		}
	},
	methods: {
		onGridReady({api}) {
			axios.get(`/api/sales_persons`)
			.then((response) => {
				this.salesPersonOptions = response.data.value;
				api.refreshCells({columns: ['SlpCode']});

			}).catch((error) => {
				console.error(error);
			});
			api.setFilterModel({
        DocStatus: { type: "set", values: ["O"] },
      });
			api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
		},
		getServerSideDatasource() {
      return {
        getRows: (params) => {
          const { filterModel, endRow, startRow, sortModel } = params.request;
          //SUBQUERY
          const subQuery = `
            SELECT 
							"DocNum", 
							"DocEntry", 
							"DocDate", 
							"DocDueDate", 
							"CardCode", 
							"CardName", 
							"DocCur", 
							"SlpCode", 
							"DocStatus",
							"U_ApprovalStatus", 
							"Comments",
							("CardCode" || ' ' || "CardName") AS "customer",
							CASE WHEN "DocCur" = 'MXP' THEN "DocTotalSy" ELSE "DocTotalFC" END AS "total"
            FROM ${this.DATABASE}."ORRR"
          `;
          //FILTERS
          let filters = ``;
          const filterModelKeys = Object.keys(filterModel);
          if (filterModelKeys.length) {
            const all = filterModelKeys.reduce((acc, key) => {
              if (filterModel[key].operator) {
                const conditionsArray = filterModel[key].conditions.map((condition) => {
                  return this.formatCondition(condition, key);
                }
              );
              const toPush = "(" + conditionsArray.join(" " + filterModel[key].operator + " ") + ")";
              acc.push(toPush);
              } else {
                const condition = this.formatCondition(filterModel[key], key);
                if(condition){
                  acc.push(condition);
                }
              }
              return acc;
            }, []);
            if(all.length){
              filters += "WHERE " + all.join(" AND ");
            }
          }
          //PAGINATION
          const pageSize = endRow - startRow;
          const pagination = `LIMIT ${pageSize} OFFSET ${startRow}`;
          //SORTING
          let sorting;
          if (sortModel.length) {
            sorting = `ORDER BY "${sortModel[0].colId}" ${sortModel[0].sort.toUpperCase()}`;
            if(sortModel[0].colId !== "DocNum"){
              sorting += `, "DocNum" DESC`;
            }
          } else {
            sorting = `ORDER BY "DocNum" DESC`;
          }
          //JSON PAYLOADS
          const rowDataJson = {
            query: `
              SELECT *
              FROM (${subQuery})
              ${filters}
              ${sorting}
              ${pagination}
            `
          };
          const totalsJson = {
            query: `
              SELECT COUNT(*) AS "rowCount"
              FROM (${subQuery})
              ${filters}
            `
          };
          // console.log("🟦rowDataJson", rowDataJson.query);
          // console.log("🟦totalsJson", totalsJson.query);
          axios
            .all([
              axios.post(`${this.HANA_URL}/api/hana/freedom`, rowDataJson),
              axios.post(`${this.HANA_URL}/api/hana/freedom`, totalsJson),
            ])
            .then(
              axios.spread((rowDataRes, totalsRes) => {
                console.log("🟪 DATA", rowDataRes.data);
                // console.log("🟪 TOTALS", totalsRes.data);
                params.success({
                  rowData: rowDataRes.data,
                  rowCount: totalsRes.data[0].rowCount,
                });
              })
            )
            .catch((err) => {
              console.error(err);
              params.fail();
            });
        },
      };
    },
		salesPersonFormatter({value}){
      if(!this.salesPersonOptions) return value;
      const salesPerson = this.salesPersonOptions.find(x => x.SalesEmployeeCode === value);
      return salesPerson ? salesPerson.SalesEmployeeName : value;
    },
		onCellClicked({data, colDef}) {
			if (colDef.field === "DocNum") {
				this.handleClick(data);
			}
		},
		onRowDoubleClicked({data}) {
			this.handleClick(data);
		},
		handleClick(data) {
			this.$router.push('/returnRequest/' + data.DocNum)
		},
	},
	created() {
		this.BASE_URL = process.env.VUE_APP_BASE_URL;
		this.HANA_URL = process.env.VUE_APP_HANA_URL;
		this.DATABASE = process.env.VUE_APP_DATABASE;
	},
}
</script>
<style>
.ag-clickable-cell {
  cursor: pointer !important;
}
.ag-clickable-cell:hover {
  background: #e9ecef !important;
}
</style>